import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import { Menu } from 'antd'

import './AdminSidebar.css'

class AdminSidebar extends React.Component {
	state = {
		current: null,
		openKeys: [],
		showMoreSections: false,
		eventCode: null,
	}
	handleClick = (event) => {
		this.setState({ current: event.key })
	}
	handleOpenChange = (openKeys) => {
		const state = this.state
		const latestOpenKey = openKeys.find(
			(key) => !(state.openKeys.indexOf(key) > -1)
		)
		const latestCloseKey = state.openKeys.find(
			(key) => !(openKeys.indexOf(key) > -1)
		)

		let nextOpenKeys = []
		if (latestOpenKey) {
			nextOpenKeys = [latestOpenKey]
		}
		if (latestCloseKey) {
			nextOpenKeys = []
		}
		let s = {}
		s.openKeys = nextOpenKeys
		this.setState(s)
	}
	handleEventChange = (event) => {
		this.setState({ eventCode: event.Code })
	}
	setStateFromProps = (props) => {
		let s = {}
		s.openKeys = [props.location.pathname.split('/')[2]]
		if (props.location.pathname.split('/').length > 2)
			s.current = props.location.pathname.split('/')[3]
		s.eventCode = props.eventCode
		this.setState(s)
	}
	toggleMoreSections = () =>
		this.setState({ showMoreSections: !this.state.showMoreSections })
	componentWillMount() {
		this.setStateFromProps(this.props)
	}
	componentWillReceiveProps(nextProps) {
		this.setStateFromProps(nextProps)
	}
	render() {
		const current = this.state.current || this.state.openKeys[0]
		return (
			<div id='adminsidebar'>
				<Menu
					mode='inline'
					openKeys={this.state.openKeys}
					selectedKeys={[current]}
					onOpenChange={this.handleOpenChange}
					onClick={this.handleClick}
				>
					<Menu.ItemGroup>
						{this.props.menuItems.map((item) => {
							if (!item.children || item.children.length === 0) {
								if (item.visible !== true) return null
								return (
									<Menu.Item key={item.key.toLowerCase()}>
										<Link
											to={
												'/portal/' +
												item.key.toLowerCase() +
												'/' +
												subitem.label
											}
										>
											<span>{subitem.label}</span>
										</Link>
									</Menu.Item>
								)
							}
							const visibleChildren = item.children.filter(
								(subitem) => subitem.visible === true
							)
							if (visibleChildren.length === 0) {
								return null
							}
							const newTitle =
								typeof item.titleText === 'string'
									? item.titleText
									: typeof item.titleText === 'function'
									? item.titleText()
									: ''
							return (
								<Menu.SubMenu
									key={item.key.toLowerCase()}
									title={
										<Link
											to={
												'/portal/' +
												item.key.toLowerCase() +
												'/' +
												item.label
											}
										>
											<span>{newTitle}</span>
										</Link>
									}
								>
									{visibleChildren.map((subitem) => {
										return (
											<Menu.Item key={subitem.label}>
												<Link
													to={
														'/portal/' +
														item.key.toLowerCase() +
														'/' +
														subitem.label
													}
												>
													{subitem.label}
												</Link>
											</Menu.Item>
										)
									})}
								</Menu.SubMenu>
							)
						})}
					</Menu.ItemGroup>
				</Menu>
			</div>
		)
	}
}

export default withRouter(AdminSidebar)



// WEBPACK FOOTER //
// ./portal-components/AdminSidebar/index.jsx